import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    service: {
        label: "",
        serviceCategoryId: null,
        serviceCategoryIds: [],
    },
    serviceList: [

    ]
}

const service = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default service;